class ModalHandler {
    constructor() {

        this.btn_modals = document.querySelectorAll('[data-modal="modal-contact-form"]');
        this.close_modal = document.getElementById('close-modal');
        this.modal = document.getElementById('modal-contact-form');
        if (this.btn_modals.length > 0) {
            this.init();
        }
    }

    init() {


        // Aggiungi un listener di eventi a ciascun elemento
        this.btn_modals.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                this.openModal(this.modal);
            });
        });

        if (this.close_modal) {
            this.close_modal.addEventListener('click', (event) => {
                event.preventDefault();
                this.closeModal(this.modal);
            });
        }

        // Listener per chiudere la modale con il tasto ESC
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' || event.keyCode === 27) {
                if (this.modal && this.modal.classList.contains('modal-active')) {
                    this.closeModal(this.modal);
                }
            }
        });

    }

    openModal(modal) {
        if (modal) {
            modal.classList.add('modal-active');
            document.body.style.overflow = 'hidden';

            // Nascondi lo sticky-block quando la modale è aperta (soprattutto su mobile)
            const stickyBlock = document.querySelector('.sticky-block-product');
            if (stickyBlock) {
                stickyBlock.style.display = 'none';
            }
        }
    }

    closeModal(modal) {
        if (modal) {
            modal.classList.remove('modal-active');
            document.body.style.overflow = 'auto';

            // Ripristina lo sticky-block quando la modale si chiude
            const stickyBlock = document.querySelector('.sticky-block-product');
            if (stickyBlock) {
                stickyBlock.style.display = '';
            }
        }
    }
}

// Inizializza la classe ModalHandler
document.addEventListener('DOMContentLoaded', () => {
    const modalHandler = new ModalHandler();

    // Controlla se l'URL contiene #modal-contact-form o #open-modal e apri automaticamente la modale
    if ((window.location.hash === '#modal-contact-form' || window.location.hash === '#open-modal') && modalHandler.modal) {
        // Scroll leggero per assicurarsi che la pagina sia caricata
        setTimeout(() => {
            modalHandler.openModal(modalHandler.modal);
            // Rimuovi l'hash dall'URL senza ricaricare la pagina
            history.replaceState(null, null, window.location.pathname + window.location.search);
        }, 100);
    }
});